import React from 'react';
import { Box } from '@mui/material';
import { Map as MapIcon } from '@mui/icons-material';
import MapView from '../../components/Map/MapView';
import PageHeader from '../../components/Common/PageHeader';

const MapPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <PageHeader
        title="Properties Map"
        subtitle="Click anywhere on the map to add a new property at that location"
        icon={<MapIcon sx={{ fontSize: 'inherit', color: 'primary.main' }} />}
        breadcrumbs={[
          { label: 'Dashboard', path: '/' },
          { label: 'Map' },
        ]}
      />

      <MapView />
    </Box>
  );
};

export default MapPage;
